import RefillMadeEasy from "../components/RefillMadeEasy";

function refillMadeEasy() {
  return (
    <div className="refill-made-easy">
       <RefillMadeEasy/>
    </div>
  );
}

export default refillMadeEasy;
